<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner3.png">
        <div class="box-font">企业新闻</div>
      </div>
    </div>
      <article class="newhome" v-cloak  style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
        <leftmenu :value='Category' :list='News_menulist' @datashow =listshow ></leftmenu>
        <!--登录-->
        <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px;width:100%; border: 1px solid #CCCCCC;">
          <el-table
              :data="this.list"
              height="750"
              style="width: 100%;font-size: 18px;padding-left:20px"
              :row-style="{}"
              :cell-style="{'font-size': '16px','padding':'20px 0px'}"
              :header-row-style="{}"
              :fit="true"
            >
              <el-table-column
                prop="Title"
                label="标题"
                width="750"
              >
              <template slot-scope="scope">                  
                  <router-link :to="'/Newsdetail?id='+scope.row.Id+'&type='+Category" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;" >{{ scope.row.Title }}</router-link>                            
                </template>
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                label="发布时间"
                width="190"
              >
              </el-table-column>
        </el-table>
      </div>
      
      </div>
      <div class="pagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 15, 20]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "News",
  components: { leftmenu, leftlogin },
  data() {
    return {
      isShow: true,
      list: [],
      currentPage:1,
      pagesize:10,
      total:0,
      News_menulist: [{
        "Word_Text":"企业新闻","Id":1,"Word_Value":1
      },{
        "Word_Text":"公司业绩","Id":2,"Word_Value":2
      },{
        "Word_Text":"通知公告","Id":3,"Word_Value":3
      }],
      Category: 1,
      form: {
        name: "",
        pass: "",
        type: ""
      }
    };
  },
  created() {    
    var that = this;
    that.Category = that.$route.query.type;    
    var list = that.News_menulist.filter(function(item){
        return item.Word_Value == that.Category
    });
    if(list.length > 0){
      if(that.Category == 1) that.getData1();
      else if(that.Category == 2) that.getData();  
       else that.getData2();   
    }
  },
  methods: {    
    getData() {
      var that = this;  
      var params = {
        PageIndex : that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: 'sort_Index desc'        
      }    
      that.$api.get("/Performance/Get", params, r => {
        that.list = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    getData1() {
      var that = this;  
      var params = {
        PageIndex : that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: 'CreateTime desc',
        Status: 1
      }    
      that.$api.get("/News/Get", params, r => {
        that.list = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    getData2() {
      var that = this;      
      var params = {
        PageIndex : that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: 'CreateTime desc'        
      }  
      that.$api.get("/Impart/Get", params, r => {
        that.list = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange (size) {
      console.log(size,'size');
      this.pagesize = size;
      this.getData()
    },
    handleCurrentChange (currentPage) {
        console.log(currentPage,'currentPage');
      this.currentPage = currentPage;
      this.getData();
    },
    listshow(item){
      var that = this;
      that.Category = item.Word_Value;
      if(that.Category == 1) that.getData1();
      else if(that.Category == 2) that.getData();  
      else that.getData2();
      return false;
    }
  },
  watch: {    
  },
  computed: {
    
  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}
.el-table .cell{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
input::-webkit-input-placeholder{
  color:#999999;
  padding: 10px 0px 16px 10px;
}
.pagination{
  text-align: center;
}
.frame-border{
  width: 204px;  
  border: 1px solid #EEEEEE;
}
.lmenu{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:#222222;
  font-size: 18px;
}
</style>
